module.exports = __webpack_public_path__ + "img/P21-en.543f45e3.png";